import React from 'react';
import AvatarOptionLabel from './avatar-option-label';
import IconOptionLabel from './icon-option-label';
import LozengeOptionLabel from './lozenge-option-label';
var formatOptionLabel = function formatOptionLabel(option) {
  if (option.optionType === 'option') {
    return /*#__PURE__*/React.createElement(IconOptionLabel, {
      option: option
    });
  }
  if (option.optionType === 'avatar') {
    return option.hideAvatar === true ? option.label : /*#__PURE__*/React.createElement(AvatarOptionLabel, {
      avatarOption: option
    });
  }
  if (option.optionType === 'lozenge') {
    return /*#__PURE__*/React.createElement(LozengeOptionLabel, {
      lozengeOption: option
    });
  }
  // eslint-disable-next-line no-console
  console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default formatOptionLabel;